<template>
  <div class="modal fade modal-job-request" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document" v-if="haveJob">
      <div class="modal-content">
        <div class="modal-header">
          Request Details
          <router-link
            @click.native="handleEditRequest"
            :to="{ name: 'jobs.edit', params: { id: job.id } }"
            class="btn btn-info btn-circle pull-right">
            <i class="fa fa-pencil"></i>
          </router-link>
        </div>
        <div class="modal-body">

          <div class="row row-clear-sm-6">
            <div class="col-sm-6">
              <p class="material-details">
                <strong>Client</strong><br />
                {{ job.user.profile.company_name }}
              </p>
            </div>
            <div class="col-sm-6">
              <p class="material-details">
                <strong>Name</strong><br />
                {{ job.user.profile.full_name }}
              </p>
            </div>
            <div class="col-sm-6">
              <p class="material-details">
                <strong>Mobile</strong><br />
                {{ job.user.mobile }}
              </p>
            </div>
            <div class="col-sm-6">
              <p class="material-details">
                <strong>Phone</strong><br />
                {{ job.user.profile.company_phone }}
              </p>
            </div>
            <div class="col-sm-6">
              <p class="material-details truncate">
                <strong>Email</strong><br />
                <a :href="`mailto:${job.user.email}`">{{ job.user.email }}</a>
              </p>
            </div>
            <div class="col-sm-6">
              <p class="material-details">
                <strong>State</strong><br />
                {{ job.user.profile.short_state }}
              </p>
            </div>
          </div>

          <h3 class="m-t-md m-b-lg">{{ job.commodity_and_location_with_quantity }}</h3>

          <div class="row row-clear-sm-6">
            <div class="col-sm-6">
              <p class="material-details">
                <strong>Start Date</strong><br />
                {{ job.start_at }}
              </p>
            </div>
            <div class="col-sm-6">
              <p class="material-details">
                <strong>End Date</strong><br />
                {{ job.end_at }}
              </p>
            </div>
            <div class="col-sm-6">
              <p class="material-details lead">
                <strong>Rate</strong><br />
                {{ job.rate }}
              </p>
            </div>
          </div>

          <p class="material-details">
            <strong>Job Notes</strong><br />
            {{ job.notes }}
          </p>

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <div class="checkbox checkbox-primary">
                  <input id="check-job-public" v-model="publicJob" class="styled" type="checkbox" />
                  <label for="check-job-public">
                    Enabled
                  </label>
                </div>
              </div><!-- /.form-group -->
            </div>
            <div class="col-sm-6">
              <ladda-button :on-click="handleSaveJobRequest" class="btn btn-sm btn-default m-t-label">Update</ladda-button>
            </div>
          </div><!-- /.row -->

          <div class="map-container">
            <distance-map ref="map" :location-from="job.location_from" :location-to="job.location_to"></distance-map>
          </div>

        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-sm-6 footer-left">
              <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Close</button>
            </div>
            <div class="col-sm-6 footer-right">
              <ladda-button :on-click="handleDeclineRequest" type="danger" size="small">Decline</ladda-button>
              <ladda-button :on-click="handleAcceptRequest" type="success" size="small">Accept</ladda-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import { RESET_JOB, SET_JOB_ATTRIBUTE } from 'vx/mutations'
  import { LaddaButton } from 'components/forms'
  import { jobRequestActionsHelpers, stateMapper } from 'mixins/jobs'
  import { pick } from 'lodash'
  import { notify } from 'utils'
  import DistanceMap from './DistanceMap'
  import $ from 'jquery'

  export default {
    mixins: [jobRequestActionsHelpers, stateMapper],

    components: {
      LaddaButton,
      DistanceMap
    },

    created () {
      this[RESET_JOB]()
    },

    /**
     * Bind event listener.
     *
     * @return void
     */
    mounted () {
      $(this.$el).on('shown.bs.modal', this.distanceMapReady)
      $(this.$el).on('hidden.bs.modal', this[RESET_JOB])
    },

    /**
     * Remove event listeners.
     *
     * @return void
     */
    beforeDestroy () {
      $(this.$el).off('shown.bs.modal', this.distanceMapReady)
      $(this.$el).off('hidden.bs.modal', this[RESET_JOB])
    },

    computed: mapGetters('job', { job: 'jobDecorated', haveJob: 'haveJob' }),

    methods: {
      ...mapMutations('job', [RESET_JOB, SET_JOB_ATTRIBUTE]),
      ...mapActions('job', ['updateJob']),

      /**
       * Emit the ready event on the distance map component.
       *
       * @return void
       */
      distanceMapReady () {
        this.$refs.map.$emit('ready')
      },

      /**
       * Handle editing the request.
       *
       * @return void
       */
      handleEditRequest () {
        $(this.$el).modal('hide')
      },

      /**
       * Handle saving the job setup.
       *
       * @return Promise
       */
      handleSaveJobRequest () {
        let payload = pick(this.job.decorated, ['public', 'user_id'])
        return this.updateJob({ id: this.job.decorated.id, payload: payload }).then(response => {
          if (response.data.public) {
            notify.success('Job is now public.')
          } else {
            notify.success('Job is no longer public.')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// JobRequestModal.vue?40a81750